import { useContext } from "react";
import Label from "./Label";
import { AppContext } from "../App";

function ProductLabels({ product, discounted = false }) {
	const { cart } = useContext(AppContext);

	const hasCashback = (product) => {
		if (
			cart &&
			cart.shop_id &&
			product.promo &&
			product.promo.cashback &&
			product.promo.cashback[cart.shop_id]?.type &&
			product.promo.cashback[cart.shop_id]?.value > 0
		)
			return true;
		return false;
	};

	const getCashbackValue = (product) => {
		if (product.promo.cashback[cart.shop_id]?.type == "percent")
			return product.promo.cashback[cart.shop_id]?.value + "%";
		else return product.promo.cashback[cart.shop_id]?.value + "€";
	};

	const showVegan = product.vegan == 1;
	const showGlutenFree = product.gluten_free == 1;
	const showDisabled = product.disabled == 1;
	const showPromo = discounted == 1;
	const showCashback = hasCashback(product);

	if (
		!showVegan &&
		!showGlutenFree &&
		!showDisabled &&
		!showPromo &&
		!showCashback
	)
		return null;

	return (
		<div className="badge-container">
			{showVegan && (
				<div className="label-vegan">
					<Label number={26} />
				</div>
			)}
			{showGlutenFree && (
				<div className="label-gluten">
					<Label number={27} />
				</div>
			)}
			{showDisabled && (
				<div className="label-available">
					<Label number={28} />
				</div>
			)}
			{showPromo && (
				<div className="label-promo">
					<Label number={174} />
				</div>
			)}
			{showCashback && (
				<div>
					<Label number={213} />
					{" " + getCashbackValue(product)}
				</div>
			)}
		</div>
	);
}

export default ProductLabels;
